import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";
import GetProductAccessoriesState from "../Data/ADIProductAccessoriesState";
import { ProductAccessoriesModel } from "@NA/Services/ProductAccessoriesService";


const initialState: GetProductAccessoriesState = {
    isLoading: false,
};

const reducer = {
    "Cart/DispatchLoadProductAccessories": (draft: Draft<GetProductAccessoriesState>, action: { result: ProductAccessoriesModel }) => {
        draft.isLoading = true;
    },
    "Cart/DispatchCompleteLoadProductAccessories": (
        draft: Draft<GetProductAccessoriesState>,
        action: { productAccessories: { result: ProductAccessoriesModel } }, 
    ) => {
        draft.isLoading = false;
        draft.productAccessoriesObj = action.productAccessories.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
